import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a/v2.0',
  redirectUri: 'https://wsi.damsy.siemens.cloud',
  clientId: '252e8b19-50aa-4c23-90c8-4b8e5d3b9a4b',
  showDebugInformation: true,
  responseType: 'code',
  scope: 'openid profile email offline_access https://ai-store-prod.siemens.com/web-ai.store',
  logoutUrl: 'https://wsi.damsy.siemens.cloud',
  skipIssuerCheck: true,
  strictDiscoveryDocumentValidation: false
};
